import styled from '@emotion/styled';
import { rem } from 'polished';

export const StyledArrowRight = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  display: block;

  &.is-right {
    z-index: 2;
    display: inline-flex;
  }

  .m-richtext p & {
    &.is-right {
      top: ${rem(7)};
      position: relative;

      .one {
        left: 32%;
      }

      .two {
        left: 32%;
      }
    }
  }

  nav .item:hover &,
  nav a:hover &,
  #navigationteaser .item:hover &,
  #navigationteaser a:hover & {
    .spline {
      opacity: 0;
    }
  }

  .item:hover &,
  a:hover & {
    .spline.one {
      transform: rotate(-135deg);
    }

    .spline.two {
      transform: rotate(135deg);
    }
  }

  .arrow-box {
    position: relative;
    width: 24px;
    height: 24px;
    display: block;
  }
`;

export const ArrowSpline = styled.span`
  height: 1px;
  margin: 0;
  width: 9px;
  background: linear-gradient(
    270deg,
    #ff7104 0%,
    rgba(255, 63, 0, 1) 50%,
    rgba(251, 129, 28, 1) 100%
  );
  transition: 0.4s ease;
  display: block;

  nav &,
  #navigationteaser & {
    height: 2px;
    background: linear-gradient(
      270deg,
      #ff7104 0%,
      rgba(255, 63, 0, 1) 90%,
      rgba(251, 129, 28, 0.9) 100%
    );
  }

  .is-right & {
    &.one {
      left: 62%;
      bottom: 60%;
    }

    &.two {
      left: 62%;
      bottom: 35%;
    }
  }

  &.one {
    position: absolute;
    transform: rotate(45deg);
    left: 16%;
    bottom: 65%;
  }

  &.two {
    position: absolute;
    transform: rotate(-45deg);
    left: 16%;
    bottom: 38%;
  }
`;
